// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star-rating {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  line-height: 1;
}

.star-button {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: inherit;
}

.star-button[disabled] {
  opacity: 0.95;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/compat/star-rating/star-rating.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".star-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  line-height: 1;\n}\n\n.star-button {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font-size: inherit;\n}\n\n.star-button[disabled] {\n  opacity: 0.95;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
